import React from 'react';
import { Trans } from 'react-i18next';
import { toast, ToastOptions } from 'react-toastify';
import { FiCheck, FiX } from 'react-icons/fi';
import { getToastClassName, getToastIcon, TTdTostType } from './toast';

type toastBoldProps = (
  i18nKey: string,
  values?: any,
  components?: any,
  settings?: ToastOptions,
) => any;

type TTDToastBoldProps = {
  i18nKey: string;
  type?: TTdTostType;
  values?: any;
  components?: any;
  settings?: ToastOptions;
};

type TTDToastBold = (props: TTDToastBoldProps) => void;

const getToastContent = (i18nKey: string, values?: any, components?: any) => (
  <div className="Toastify__toast-text">
    <Trans
      i18nKey={i18nKey}
      values={values}
      components={{ bold: <strong />, ...components }}
    />
  </div>
);

/**
 * @param i18nKey ключ перевода обязательно
 */
export const tdToastBold: TTDToastBold = ({
  i18nKey,
  type = 'DEFAULT',
  values = {},
  components = {},
  settings = {},
}) => {
  toast(getToastContent(i18nKey, values, components), {
    icon: getToastIcon(type),
    position: toast.POSITION.TOP_RIGHT,
    className: getToastClassName(type),
    ...settings,
  });
};

export const toastDefaultBold: toastBoldProps = (
  i18nKey,
  values = {},
  components = {},
  settings = {},
) =>
  toast(
    <div className="Toastify__toast-text">
      <Trans
        i18nKey={i18nKey}
        values={values}
        components={{ bold: <strong />, ...components }}
      />
    </div>,
    {
      position: toast.POSITION.TOP_RIGHT,
      className: 'Toastify__toast--default',
      ...settings,
    },
  );

export const toastSuccessBold: toastBoldProps = (
  i18nKey,
  values = {},
  components = {},
  settings = {},
) =>
  toast(
    <div className="Toastify__toast-text">
      <Trans
        i18nKey={i18nKey}
        values={values}
        components={{ bold: <strong />, ...components }}
      />
    </div>,
    {
      icon: <FiCheck className="_isSuccess" />,
      position: toast.POSITION.TOP_RIGHT,
      className: 'Toastify__toast--success',
      ...settings,
    },
  );

export const toastErrorBold: toastBoldProps = (
  i18nKey,
  values = {},
  components = {},
  settings = {},
) =>
  toast(
    <div className="Toastify__toast-text">
      <Trans
        i18nKey={i18nKey}
        values={values}
        components={{ bold: <strong />, ...components }}
      />
    </div>,
    {
      icon: <FiX className="_isError" />,
      position: toast.POSITION.TOP_RIGHT,
      className: 'Toastify__toast--error',
      ...settings,
    },
  );
